/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 10/08/2020.
 * @module Identity
 * @description Identity module
 */
import React, { useCallback, useEffect } from "react";
import { Outlet } from "react-router-dom";
import AppConfiguration from "dataProvider/config";
import { OAuth2CallbackHandler } from "lib/gmjs";
import { useNavigate } from "react-router";


const IdentityComponent = () => {
  const navigate = useNavigate();
  const handler = OAuth2CallbackHandler(AppConfiguration.ghtkID.oidc);
  const getCallbackHandler = useCallback(async () => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const deviceId = params.get("device_id");

    localStorage.setItem("device_id", deviceId || "");
    if (await handler.handle()) {
      // Login successfully
      setTimeout(() => {
        navigate(handler.getRefererPath() || "/");
      }, 200);
    }
  }, [handler]);
  useEffect(() => {
    getCallbackHandler();
  }, [getCallbackHandler]);
  return <Outlet />;
};
export default IdentityComponent;
